"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityParsers = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const businessRuleTaskParser = require("./BusinessRuleTaskParser");
const callActivityParser = require("./CallActivityParser");
const emptyActivityParser = require("./EmptyActivityParser");
const manualTaskParser = require("./ManualTaskParser");
const receiveTaskParser = require("./ReceiveTaskParser");
const scriptTaskParser = require("./ScriptTaskParser");
const sendTaskParser = require("./SendTaskParser");
const serviceTaskParser = require("./ServiceTaskParser");
const subProcessParser = require("./SubprocessParser");
const userTaskParser = require("./UserTaskParser");
var ActivityParsers;
(function (ActivityParsers) {
    ActivityParsers.BusinessRuleTaskParser = businessRuleTaskParser;
    ActivityParsers.CallActivityParser = callActivityParser;
    ActivityParsers.EmptyActivityParser = emptyActivityParser;
    ActivityParsers.ManualTaskParser = manualTaskParser;
    ActivityParsers.ReceiveTaskParser = receiveTaskParser;
    ActivityParsers.ScriptTaskParser = scriptTaskParser;
    ActivityParsers.SendTaskParser = sendTaskParser;
    ActivityParsers.ServiceTaskParser = serviceTaskParser;
    ActivityParsers.SubProcessParser = subProcessParser;
    ActivityParsers.UserTaskParser = userTaskParser;
})(ActivityParsers = exports.ActivityParsers || (exports.ActivityParsers = {}));
//# sourceMappingURL=index.js.map